module.exports = __webpack_public_path__ + "static/media/drop_checkbox.eaca8137.svg";